import { PropsWithChildren } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { c7A35CB, cFFFFFF } from '#/colors';

export default function ErrorPage({ children }: PropsWithChildren<unknown>) {
  const resetStateAndReload = () => {
    window.location.reload();
  };

  return (
    <Container>
      <Title>Oops!</Title>
      <Paragraph>{children}</Paragraph>
      <Button onClick={resetStateAndReload}>Refresh</Button>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  place-items: center;
  align-content: center;
  height: 100%;
  gap: 16px;
`;

const Title = styled.h1`
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

const Paragraph = styled.p`
  color: ${rgba(cFFFFFF, 0.7)};
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  text-align: center;
`;

const Button = styled.button.attrs({ type: 'button' })`
  background-color: ${c7A35CB};
  border-radius: 7px;
  border: none;
  color: ${cFFFFFF};
  font-size: 13px;
  font-weight: 700;
  height: 32px;
  width: 125px;
  margin-top: 14px;
`;
